module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('demonstration', {
    attrs: {
      "tag": "h2",
      "title": "Collapse 折叠面板",
      "description": "通过折叠面板收纳内容区域",
      "show-content": false
    }
  }), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "真实案例",
      "anchor": "zhen-shi-an-li"
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n      通过多个组件（"), _c('a', {
    attrs: {
      "href": "https://github.com/vue-multiple/collapse"
    }
  }, [_vm._v("Collapse折叠面板")]), _vm._v("，"), _c('a', {
    attrs: {
      "href": "https://github.com/vue-multiple/rate"
    }
  }, [_vm._v("Rate评分")]), _vm._v("，"), _c('a', {
    attrs: {
      "href": "https://github.com/vue-multiple/tabs"
    }
  }, [_vm._v("Tabs标签页")]), _vm._v("）结合\n    ")]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('best-rating', {
    attrs: {
      "data": _vm.bestRatingData
    }
  })], 1)], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "description": "可同时展开多个面板，面板之间不影响",
      "anchor": "ji-chu-yong-fa",
      "highlight": _vm.sourcecodeA,
      "multiple": true
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n      基础用法 "), _c('i', {
    staticClass: "vd-demo__new"
  }, [_vm._v("（改进特性）")])]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "vd-demo__block vd-demo__block-2"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("默认")]), _vm._v(" "), _c('vm-collapse', {
    model: {
      value: (_vm.activeNamesA),
      callback: function($$v) {
        _vm.activeNamesA = $$v
      },
      expression: "activeNamesA"
    }
  }, [_c('vm-collapse-item', {
    attrs: {
      "title": "一致性 Consistency",
      "name": "1"
    }
  }, [_c('div', [_vm._v("与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；")]), _vm._v(" "), _c('div', [_vm._v("在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "反馈 Feedback",
      "name": "2"
    }
  }, [_c('div', [_vm._v("控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；")]), _vm._v(" "), _c('div', [_vm._v("页面反馈：操作后，通过页面元素的变化清晰地展现当前状态。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "效率 Efficiency",
      "name": "3"
    }
  }, [_c('div', [_vm._v("简化流程：设计简洁直观的操作流程；")]), _vm._v(" "), _c('div', [_vm._v("清晰明确：语言表达清晰且表意明确，让用户快速理解进而作出决策；")]), _vm._v(" "), _c('div', [_vm._v("帮助用户识别：界面简单直白，让用户快速识别而非回忆，减少用户记忆负担。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "可控 Controllability",
      "name": "4"
    }
  }, [_c('div', [_vm._v("用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；")]), _vm._v(" "), _c('div', [_vm._v("结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "vd-demo__block vd-demo__block-2"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("带边框")]), _vm._v(" "), _c('vm-collapse', {
    staticClass: "vm-collapse--bordered",
    model: {
      value: (_vm.activeNamesB),
      callback: function($$v) {
        _vm.activeNamesB = $$v
      },
      expression: "activeNamesB"
    }
  }, [_c('vm-collapse-item', {
    attrs: {
      "title": "一致性 Consistency",
      "name": "1"
    }
  }, [_c('div', [_vm._v("与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；")]), _vm._v(" "), _c('div', [_vm._v("在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "反馈 Feedback",
      "name": "2"
    }
  }, [_c('div', [_vm._v("控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；")]), _vm._v(" "), _c('div', [_vm._v("页面反馈：操作后，通过页面元素的变化清晰地展现当前状态。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "效率 Efficiency",
      "name": "3"
    }
  }, [_c('div', [_vm._v("简化流程：设计简洁直观的操作流程；")]), _vm._v(" "), _c('div', [_vm._v("清晰明确：语言表达清晰且表意明确，让用户快速理解进而作出决策；")]), _vm._v(" "), _c('div', [_vm._v("帮助用户识别：界面简单直白，让用户快速识别而非回忆，减少用户记忆负担。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "可控 Controllability",
      "name": "4"
    }
  }, [_c('div', [_vm._v("用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；")]), _vm._v(" "), _c('div', [_vm._v("结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。")])])], 1)], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n      通过添加 "), _c('code', [_vm._v("vm-collapse")]), _vm._v(" 组件添加 "), _c('code', [_vm._v("class=\"vm-collapse--bordered\"")]), _vm._v(" 来为组件添加边框。\n    ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "手风琴效果",
      "anchor": "shou-feng-qin-xiao-guo",
      "highlight": _vm.sourcecodeB,
      "multiple": true
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n      每次只能展开一个面板\n    ")]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "vd-demo__block vd-demo__block-2"
  }, [_c('vm-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.activeNamesC),
      callback: function($$v) {
        _vm.activeNamesC = $$v
      },
      expression: "activeNamesC"
    }
  }, [_c('vm-collapse-item', {
    attrs: {
      "title": "一致性 Consistency",
      "name": "1"
    }
  }, [_c('div', [_vm._v("与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；")]), _vm._v(" "), _c('div', [_vm._v("在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "反馈 Feedback",
      "name": "2"
    }
  }, [_c('div', [_vm._v("控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；")]), _vm._v(" "), _c('div', [_vm._v("页面反馈：操作后，通过页面元素的变化清晰地展现当前状态。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "效率 Efficiency",
      "name": "3"
    }
  }, [_c('div', [_vm._v("简化流程：设计简洁直观的操作流程；")]), _vm._v(" "), _c('div', [_vm._v("清晰明确：语言表达清晰且表意明确，让用户快速理解进而作出决策；")]), _vm._v(" "), _c('div', [_vm._v("帮助用户识别：界面简单直白，让用户快速识别而非回忆，减少用户记忆负担。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "可控 Controllability",
      "name": "4"
    }
  }, [_c('div', [_vm._v("用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；")]), _vm._v(" "), _c('div', [_vm._v("结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。")])])], 1)], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n      通过 "), _c('code', [_vm._v("accordion")]), _vm._v(" 属性来设置是否以手风琴模式显示。\n    ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "description": "每次展开只显示内容，收缩只显示标题",
      "anchor": "bian-huan",
      "highlight": _vm.sourcecodeC,
      "multiple": true
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n      变换 "), _c('i', {
    staticClass: "vd-demo__new"
  }, [_vm._v("（新增特性，新增示例）")])]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "vd-demo__block vd-demo__block-2"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("默认模式下")]), _vm._v(" "), _c('vm-collapse', {
    attrs: {
      "transform": ""
    },
    model: {
      value: (_vm.activeNamesD),
      callback: function($$v) {
        _vm.activeNamesD = $$v
      },
      expression: "activeNamesD"
    }
  }, [_c('vm-collapse-item', {
    attrs: {
      "title": "一致性 Consistency",
      "name": "1"
    }
  }, [_c('div', [_vm._v("与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；")]), _vm._v(" "), _c('div', [_vm._v("在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "反馈 Feedback",
      "name": "2"
    }
  }, [_c('div', [_vm._v("控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；")]), _vm._v(" "), _c('div', [_vm._v("页面反馈：操作后，通过页面元素的变化清晰地展现当前状态。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "效率 Efficiency",
      "name": "3"
    }
  }, [_c('div', [_vm._v("简化流程：设计简洁直观的操作流程；")]), _vm._v(" "), _c('div', [_vm._v("清晰明确：语言表达清晰且表意明确，让用户快速理解进而作出决策；")]), _vm._v(" "), _c('div', [_vm._v("帮助用户识别：界面简单直白，让用户快速识别而非回忆，减少用户记忆负担。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "可控 Controllability",
      "name": "4"
    }
  }, [_c('div', [_vm._v("用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；")]), _vm._v(" "), _c('div', [_vm._v("结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "vd-demo__block vd-demo__block-2"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("手风琴模式下")]), _vm._v(" "), _c('vm-collapse', {
    attrs: {
      "accordion": "",
      "transform": ""
    },
    model: {
      value: (_vm.activeNamesE),
      callback: function($$v) {
        _vm.activeNamesE = $$v
      },
      expression: "activeNamesE"
    }
  }, [_c('vm-collapse-item', {
    attrs: {
      "title": "一致性 Consistency",
      "name": "1"
    }
  }, [_c('div', [_vm._v("与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；")]), _vm._v(" "), _c('div', [_vm._v("在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "反馈 Feedback",
      "name": "2"
    }
  }, [_c('div', [_vm._v("控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；")]), _vm._v(" "), _c('div', [_vm._v("页面反馈：操作后，通过页面元素的变化清晰地展现当前状态。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "效率 Efficiency",
      "name": "3"
    }
  }, [_c('div', [_vm._v("简化流程：设计简洁直观的操作流程；")]), _vm._v(" "), _c('div', [_vm._v("清晰明确：语言表达清晰且表意明确，让用户快速理解进而作出决策；")]), _vm._v(" "), _c('div', [_vm._v("帮助用户识别：界面简单直白，让用户快速识别而非回忆，减少用户记忆负担。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "可控 Controllability",
      "name": "4"
    }
  }, [_c('div', [_vm._v("用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；")]), _vm._v(" "), _c('div', [_vm._v("结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。")])])], 1)], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n      通过 "), _c('code', [_vm._v("transform")]), _vm._v(" 属性来设置是否以变换模式显示。\n    ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "description": "控制展开面板的数量",
      "anchor": "duo-ge-zhan-kai-mian-ban",
      "highlight": _vm.sourcecodeD,
      "multiple": true
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n      多个展开面板 "), _c('i', {
    staticClass: "vd-demo__new"
  }, [_vm._v("（新增特性，新增示例）")])]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "vd-demo__block vd-demo__block-2"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("默认模式下")]), _vm._v(" "), _c('vm-collapse', {
    attrs: {
      "remain": 2
    },
    model: {
      value: (_vm.activeNamesF),
      callback: function($$v) {
        _vm.activeNamesF = $$v
      },
      expression: "activeNamesF"
    }
  }, [_c('vm-collapse-item', {
    attrs: {
      "title": "一致性 Consistency",
      "name": "1"
    }
  }, [_c('div', [_vm._v("与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；")]), _vm._v(" "), _c('div', [_vm._v("在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "反馈 Feedback",
      "name": "2"
    }
  }, [_c('div', [_vm._v("控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；")]), _vm._v(" "), _c('div', [_vm._v("页面反馈：操作后，通过页面元素的变化清晰地展现当前状态。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "效率 Efficiency",
      "name": "3"
    }
  }, [_c('div', [_vm._v("简化流程：设计简洁直观的操作流程；")]), _vm._v(" "), _c('div', [_vm._v("清晰明确：语言表达清晰且表意明确，让用户快速理解进而作出决策；")]), _vm._v(" "), _c('div', [_vm._v("帮助用户识别：界面简单直白，让用户快速识别而非回忆，减少用户记忆负担。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "可控 Controllability",
      "name": "4"
    }
  }, [_c('div', [_vm._v("用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；")]), _vm._v(" "), _c('div', [_vm._v("结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "vd-demo__block vd-demo__block-2"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("默认模式下（可关闭）")]), _vm._v(" "), _c('vm-collapse', {
    attrs: {
      "remain": 2,
      "closable": ""
    },
    model: {
      value: (_vm.activeNamesG),
      callback: function($$v) {
        _vm.activeNamesG = $$v
      },
      expression: "activeNamesG"
    }
  }, [_c('vm-collapse-item', {
    attrs: {
      "title": "一致性 Consistency",
      "name": "1"
    }
  }, [_c('div', [_vm._v("与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；")]), _vm._v(" "), _c('div', [_vm._v("在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "反馈 Feedback",
      "name": "2"
    }
  }, [_c('div', [_vm._v("控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；")]), _vm._v(" "), _c('div', [_vm._v("页面反馈：操作后，通过页面元素的变化清晰地展现当前状态。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "效率 Efficiency",
      "name": "3"
    }
  }, [_c('div', [_vm._v("简化流程：设计简洁直观的操作流程；")]), _vm._v(" "), _c('div', [_vm._v("清晰明确：语言表达清晰且表意明确，让用户快速理解进而作出决策；")]), _vm._v(" "), _c('div', [_vm._v("帮助用户识别：界面简单直白，让用户快速识别而非回忆，减少用户记忆负担。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "可控 Controllability",
      "name": "4"
    }
  }, [_c('div', [_vm._v("用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；")]), _vm._v(" "), _c('div', [_vm._v("结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "vd-demo__block vd-demo__block-2"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("手风琴模式下（"), _c('i', {
    staticClass: "vd-demo__new"
  }, [_vm._v("无效")]), _vm._v("）")]), _vm._v(" "), _c('vm-collapse', {
    attrs: {
      "accordion": "",
      "remain": 2
    },
    model: {
      value: (_vm.activeNamesH),
      callback: function($$v) {
        _vm.activeNamesH = $$v
      },
      expression: "activeNamesH"
    }
  }, [_c('vm-collapse-item', {
    attrs: {
      "title": "一致性 Consistency",
      "name": "1"
    }
  }, [_c('div', [_vm._v("与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；")]), _vm._v(" "), _c('div', [_vm._v("在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "反馈 Feedback",
      "name": "2"
    }
  }, [_c('div', [_vm._v("控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；")]), _vm._v(" "), _c('div', [_vm._v("页面反馈：操作后，通过页面元素的变化清晰地展现当前状态。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "效率 Efficiency",
      "name": "3"
    }
  }, [_c('div', [_vm._v("简化流程：设计简洁直观的操作流程；")]), _vm._v(" "), _c('div', [_vm._v("清晰明确：语言表达清晰且表意明确，让用户快速理解进而作出决策；")]), _vm._v(" "), _c('div', [_vm._v("帮助用户识别：界面简单直白，让用户快速识别而非回忆，减少用户记忆负担。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "可控 Controllability",
      "name": "4"
    }
  }, [_c('div', [_vm._v("用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；")]), _vm._v(" "), _c('div', [_vm._v("结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "vd-demo__block vd-demo__block-2"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("变换模式下")]), _vm._v(" "), _c('vm-collapse', {
    attrs: {
      "transform": "",
      "remain": 2
    },
    model: {
      value: (_vm.activeNamesI),
      callback: function($$v) {
        _vm.activeNamesI = $$v
      },
      expression: "activeNamesI"
    }
  }, [_c('vm-collapse-item', {
    attrs: {
      "title": "一致性 Consistency",
      "name": "1"
    }
  }, [_c('div', [_vm._v("与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；")]), _vm._v(" "), _c('div', [_vm._v("在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "反馈 Feedback",
      "name": "2"
    }
  }, [_c('div', [_vm._v("控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；")]), _vm._v(" "), _c('div', [_vm._v("页面反馈：操作后，通过页面元素的变化清晰地展现当前状态。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "效率 Efficiency",
      "name": "3"
    }
  }, [_c('div', [_vm._v("简化流程：设计简洁直观的操作流程；")]), _vm._v(" "), _c('div', [_vm._v("清晰明确：语言表达清晰且表意明确，让用户快速理解进而作出决策；")]), _vm._v(" "), _c('div', [_vm._v("帮助用户识别：界面简单直白，让用户快速识别而非回忆，减少用户记忆负担。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "可控 Controllability",
      "name": "4"
    }
  }, [_c('div', [_vm._v("用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；")]), _vm._v(" "), _c('div', [_vm._v("结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。")])])], 1)], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n      通过 "), _c('code', [_vm._v("remain")]), _vm._v(" 属性来设置最多展开面板的数量，同时指定 "), _c('code', [_vm._v("closable")]), _vm._v(" 属性来设置是否可以关闭展开的面板。\n    ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "anchor": "zi-ding-yi-mian-ban",
      "highlight": _vm.sourcecodeE,
      "multiple": true
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n      自定义面板 "), _c('i', {
    staticClass: "vd-demo__new"
  }, [_vm._v("（改进特性，新增示例）")])]), _vm._v(" "), _c('template', {
    slot: "description"
  }, [_vm._v("\n      除了可以通过 "), _c('code', [_vm._v("title")]), _vm._v(" 属性以外，还可以通过具名 "), _c('code', [_vm._v("slot=\"title\"")]), _vm._v(" 来实现自定义面板的标题内容，以实现增加图标等效果。还可以通过 具名 "), _c('code', [_vm._v("slot=\"header\" 来实现自定义面板的头部内容。")])]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "vd-demo__block vd-demo__block-2"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("自定义标题")]), _vm._v(" "), _c('vm-collapse', {
    model: {
      value: (_vm.activeNamesJ),
      callback: function($$v) {
        _vm.activeNamesJ = $$v
      },
      expression: "activeNamesJ"
    }
  }, [_c('vm-collapse-item', {
    attrs: {
      "title": "一致性 Consistency",
      "name": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n              自定义标题\n            ")]), _vm._v(" "), _c('div', [_vm._v("与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；")]), _vm._v(" "), _c('div', [_vm._v("在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。")])], 2), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "反馈 Feedback",
      "name": "2"
    }
  }, [_c('div', [_vm._v("控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；")]), _vm._v(" "), _c('div', [_vm._v("页面反馈：操作后，通过页面元素的变化清晰地展现当前状态。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "效率 Efficiency",
      "name": "3"
    }
  }, [_c('div', [_vm._v("简化流程：设计简洁直观的操作流程；")]), _vm._v(" "), _c('div', [_vm._v("清晰明确：语言表达清晰且表意明确，让用户快速理解进而作出决策；")]), _vm._v(" "), _c('div', [_vm._v("帮助用户识别：界面简单直白，让用户快速识别而非回忆，减少用户记忆负担。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "可控 Controllability",
      "name": "4"
    }
  }, [_c('div', [_vm._v("用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；")]), _vm._v(" "), _c('div', [_vm._v("结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "vd-demo__block vd-demo__block-2"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("自定义头部")]), _vm._v(" "), _c('vm-collapse', {
    model: {
      value: (_vm.activeNamesK),
      callback: function($$v) {
        _vm.activeNamesK = $$v
      },
      expression: "activeNamesK"
    }
  }, [_c('vm-collapse-item', {
    attrs: {
      "title": "一致性 Consistency",
      "name": "1"
    }
  }, [_c('template', {
    slot: "header"
  }, [_vm._v("\n              自定义头部\n            ")]), _vm._v(" "), _c('div', [_vm._v("与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；")]), _vm._v(" "), _c('div', [_vm._v("在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。")])], 2), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "反馈 Feedback",
      "name": "2"
    }
  }, [_c('div', [_vm._v("控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；")]), _vm._v(" "), _c('div', [_vm._v("页面反馈：操作后，通过页面元素的变化清晰地展现当前状态。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "效率 Efficiency",
      "name": "3"
    }
  }, [_c('div', [_vm._v("简化流程：设计简洁直观的操作流程；")]), _vm._v(" "), _c('div', [_vm._v("清晰明确：语言表达清晰且表意明确，让用户快速理解进而作出决策；")]), _vm._v(" "), _c('div', [_vm._v("帮助用户识别：界面简单直白，让用户快速识别而非回忆，减少用户记忆负担。")])]), _vm._v(" "), _c('vm-collapse-item', {
    attrs: {
      "title": "可控 Controllability",
      "name": "4"
    }
  }, [_c('div', [_vm._v("用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；")]), _vm._v(" "), _c('div', [_vm._v("结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。")])])], 1)], 1)])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "Collapse Attributes",
      "anchor": "collapse-attributes",
      "show-content": false
    }
  }, [_c('template', {
    slot: "table"
  }, [_c('table', {
    staticClass: "vd-demo__table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("可选值")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("accordion")]), _vm._v(" "), _c('td', [_vm._v("是否手风琴模式")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("transform "), _c('i', {
    staticClass: "vd-demo__new"
  }, [_vm._v("（新增）")])]), _vm._v(" "), _c('td', [_vm._v("是否变换模式")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("remain "), _c('i', {
    staticClass: "vd-demo__new"
  }, [_vm._v("（新增）")])]), _vm._v(" "), _c('td', [_vm._v("最多展开面板的数量")]), _vm._v(" "), _c('td', [_vm._v("number")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("0")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("closable "), _c('i', {
    staticClass: "vd-demo__new"
  }, [_vm._v("（新增）")])]), _vm._v(" "), _c('td', [_vm._v("展开面板数量>=指定remain值是，被激活的面板是否可关闭")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("value")]), _vm._v(" "), _c('td', [_vm._v("当前激活的面板(如果是手风琴模式，绑定值类型需要为"), _c('code', [_vm._v("string")]), _vm._v("，否则为"), _c('code', [_vm._v("array")]), _vm._v(")")]), _vm._v(" "), _c('td', [_vm._v("string/array")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])])])])])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "Collapse Events",
      "anchor": "collapse-events",
      "show-content": false
    }
  }, [_c('template', {
    slot: "table"
  }, [_c('table', {
    staticClass: "vd-demo__table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("事件名称")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("回调参数")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("change")]), _vm._v(" "), _c('td', [_vm._v("当前激活面板改变时触发(如果是手风琴模式，参数 "), _c('code', [_vm._v("activeNames")]), _vm._v(" 类型为"), _c('code', [_vm._v("string")]), _vm._v("，否则为"), _c('code', [_vm._v("array")]), _vm._v(")")]), _vm._v(" "), _c('td', [_vm._v("(activeNames: array|string)")])])])])])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "Collapse Item Attributes",
      "anchor": "collapse-item-attributes",
      "show-content": false
    }
  }, [_c('template', {
    slot: "table"
  }, [_c('table', {
    staticClass: "vd-demo__table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("可选值")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("name")]), _vm._v(" "), _c('td', [_vm._v("唯一标志符")]), _vm._v(" "), _c('td', [_vm._v("string/number")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("title")]), _vm._v(" "), _c('td', [_vm._v("面板标题")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])])])])])], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-29fac75d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29fac75d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/src/App.vue
// module id = 24
// module chunks = 0